var _defs, _g, _g2, _g3, _g4, _g5, _g6, _line, _g7, _line2, _g8, _g9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewCeilingToWindow3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "221px",
    height: "244px",
    viewBox: "0 0 588 650",
    enableBackground: "new 0 0 588 650",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n\t\t\t@font-face {\r\n\t\t\tfont-family: \"proximanova-nova\";\r\n\r\n\t\t\tsrc: url('https://doopsalta2.com/Fonts/proxima-nova-three.woff2') format('woff2'),\r\n\t\t\t\turl('https://doopsalta2.com/Fonts/proxima-nova-three.woff') format('woff'),\r\n\t\t\t\turl('https://doopsalta2.com/Fonts/proxima-nova-three.otf') format('opentype');\r\n\t\t\tfont-style: normal;\r\n\t\t\t}\r\n\t\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M130,20.3l7.8-19.1h3l7.7,19.1h-2.7L144,16h-9.6l-1.7,4.3H130z M135.1,13.9h8.1l-4.1-10.3L135.1,13.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M222.5,20.3V1.1h8.5c1.7,0,3,0.5,3.9,1.3c1,1,1.4,2,1.4,3.6c0,1.2-0.4,2.2-1,2.9c-0.6,0.7-1.4,1.3-2.4,1.4 c1,0.1,1.9,0.7,2.6,1.7c0.7,1,1.1,1.9,1.1,3.1c0,1.6-0.5,2.9-1.4,3.7c-1,1-2.4,1.4-4.1,1.4H222.5z M224.9,9.4h5.7 c1.1,0,1.9-0.2,2.4-0.8c0.5-0.6,0.8-1.3,0.8-2.2s-0.2-1.7-0.8-2.3c-0.6-0.6-1.4-0.8-2.4-0.8h-5.7V9.4z M224.9,18.1h5.9 c1.1,0,1.9-0.2,2.6-0.8c0.6-0.6,1-1.4,1-2.4s-0.4-1.7-1-2.4c-0.6-0.7-1.4-1-2.6-1h-5.9V18.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M312.8,14.8c-0.5-1.2-0.7-2.6-0.7-4.1s0.2-2.7,0.7-4.1c0.5-1.2,1.2-2.3,2-3.1c0.8-0.8,1.9-1.6,3.1-2 c1.2-0.5,2.5-0.7,3.8-0.7c3.1,0,5.5,1.3,7.3,3.8l-2,1.1c-0.6-0.8-1.3-1.6-2.3-2c-1-0.5-1.9-0.7-3-0.7c-2.2,0-3.8,0.7-5.3,2.2 s-2.2,3.3-2.2,5.6c0,1.4,0.4,2.9,1,4.1c0.6,1.2,1.6,2.2,2.6,2.7c1.1,0.7,2.4,1,3.7,1c1.1,0,2-0.2,3-0.7c1-0.5,1.7-1.2,2.3-2l2,1.1 c-1.9,2.5-4.3,3.8-7.3,3.8c-1.3,0-2.6-0.2-3.8-0.7c-1.2-0.5-2.3-1.2-3.1-2C314,17,313.3,16,312.8,14.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 320.6,
    y1: 82.6,
    x2: 320.6,
    y2: 552.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "311.6,85.2 320.6,69.7 329.5,85.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "311.6,550.1 320.6,565.7 329.5,550.1  "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 229.4,
    y1: 82.6,
    x2: 229.4,
    y2: 552.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "220.4,85.2 229.4,69.7 238.3,85.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "220.4,550.1 229.4,565.7 238.3,550.1  "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 139.2,
    y1: 82.6,
    x2: 139.2,
    y2: 552.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "130.2,85.2 139.2,69.7 148.2,85.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "130.2,550.1 139.2,565.7 148.2,550.1  "
  }))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9679,
    x1: 0,
    y1: 645.2,
    x2: 460,
    y2: 645.2
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 89.9,
    y: 176.7,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 199.8,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9679,
    x1: 0,
    y1: 69.7,
    x2: 460,
    y2: 69.7
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M476.2,65c-0.4-1-0.6-2.1-0.6-3.2c0-1.2,0.2-2.2,0.6-3.2c0.4-1,1-1.8,1.7-2.5c0.7-0.7,1.5-1.2,2.5-1.6 c1-0.4,2-0.6,3.1-0.6c2.5,0,4.4,1,5.8,3l-1.6,0.9c-0.4-0.7-1.1-1.2-1.8-1.6c-0.8-0.4-1.6-0.6-2.4-0.6c-1.7,0-3.1,0.6-4.2,1.7 s-1.7,2.7-1.7,4.5c0,1.2,0.3,2.3,0.8,3.2s1.2,1.7,2.1,2.2c0.9,0.5,1.9,0.8,3,0.8c0.9,0,1.7-0.2,2.4-0.6s1.4-1,1.8-1.6l1.6,0.9 c-1.5,2-3.4,3.1-5.8,3.1c-1.1,0-2.1-0.2-3.1-0.6c-1-0.4-1.8-0.9-2.5-1.6C477.1,66.8,476.6,66,476.2,65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M494,69.4V54.1h10.1v1.7h-8.1v4.9h8v1.7h-8v5.3h8.1v1.7H494z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M509.4,69.4V54.1h1.9v15.3H509.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M516.9,69.4V54.1h1.9v13.6h7.1v1.7H516.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M530.8,69.4V54.1h1.9v15.3H530.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M538.6,69.4V54.1h2l8.8,12v-12h1.9v15.3h-1.8l-8.9-12.2v12.2H538.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M557.2,65c-0.4-1-0.6-2.1-0.6-3.3s0.2-2.3,0.6-3.3s1-1.8,1.7-2.5c0.7-0.7,1.5-1.2,2.5-1.6 c1-0.4,2-0.6,3.1-0.6c2.4,0,4.4,1,6,2.9l-1.5,1c-0.5-0.6-1.1-1.2-1.9-1.5c-0.8-0.4-1.6-0.6-2.5-0.6c-1.7,0-3.1,0.6-4.2,1.7 s-1.7,2.7-1.7,4.5c0,1.2,0.3,2.3,0.8,3.2c0.5,1,1.2,1.7,2.1,2.2c0.9,0.5,1.9,0.8,3,0.8c0.8,0,1.6-0.2,2.4-0.5 c0.7-0.3,1.3-0.7,1.8-1.2v-3.1h-5.3v-1.7h7.2V67c-0.7,0.8-1.6,1.5-2.7,1.9s-2.2,0.7-3.4,0.7c-1.1,0-2.1-0.2-3.1-0.6 c-1-0.4-1.8-0.9-2.5-1.6C558.2,66.8,557.6,66,557.2,65z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M475.6,644.9v-15.3h10.1v1.7h-8.1v4.9h8v1.7h-8v7H475.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M490.3,644.9v-15.3h1.9v13.6h7.1v1.7H490.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M504.5,641.3c-0.6-1.2-0.9-2.6-0.9-4.1s0.3-2.8,0.9-4.1c0.6-1.2,1.5-2.2,2.7-2.8s2.5-1,4-1 c1.5,0,2.8,0.3,4,1c1.2,0.7,2.1,1.6,2.7,2.8c0.6,1.2,1,2.6,1,4.1s-0.3,2.8-1,4.1c-0.6,1.2-1.5,2.2-2.7,2.8c-1.2,0.7-2.5,1-4,1 c-1.5,0-2.8-0.3-4-1S505.1,642.5,504.5,641.3z M505.5,637.3c0,1.2,0.2,2.2,0.7,3.2c0.5,0.9,1.1,1.7,2,2.2c0.9,0.5,1.9,0.8,3,0.8 s2.1-0.3,3-0.8c0.9-0.5,1.5-1.3,2-2.2s0.7-2,0.7-3.2c0-1.8-0.5-3.3-1.6-4.5c-1-1.2-2.4-1.8-4.1-1.8c-1.7,0-3.1,0.6-4.1,1.8 C506,633.9,505.5,635.4,505.5,637.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M524.4,641.3c-0.6-1.2-0.9-2.6-0.9-4.1s0.3-2.8,0.9-4.1c0.6-1.2,1.5-2.2,2.7-2.8s2.5-1,4-1 c1.5,0,2.8,0.3,4,1c1.2,0.7,2.1,1.6,2.7,2.8c0.6,1.2,1,2.6,1,4.1s-0.3,2.8-1,4.1c-0.6,1.2-1.5,2.2-2.7,2.8c-1.2,0.7-2.5,1-4,1 c-1.5,0-2.8-0.3-4-1S525,642.5,524.4,641.3z M525.4,637.3c0,1.2,0.2,2.2,0.7,3.2c0.5,0.9,1.1,1.7,2,2.2c0.9,0.5,1.9,0.8,3,0.8 s2.1-0.3,3-0.8c0.9-0.5,1.5-1.3,2-2.2s0.7-2,0.7-3.2c0-1.8-0.5-3.3-1.6-4.5c-1-1.2-2.4-1.8-4.1-1.8c-1.7,0-3.1,0.6-4.1,1.8 C525.9,633.9,525.4,635.4,525.4,637.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M543.9,644.9v-15.3h6.2c1.4,0,2.6,0.4,3.5,1.3c0.9,0.8,1.3,2,1.3,3.4c0,0.7-0.1,1.3-0.3,1.8 c-0.2,0.6-0.5,1-0.9,1.4c-0.4,0.4-0.8,0.7-1.3,0.9s-1,0.3-1.5,0.4l4.1,6.2h-2.3l-3.9-6.1h-3.1v6.1H543.9z M545.8,637.1h4 c0.9,0,1.6-0.3,2.2-0.8c0.6-0.5,0.9-1.3,0.9-2.1s-0.3-1.6-0.9-2.1c-0.6-0.5-1.3-0.8-2.2-0.8h-4V637.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCeilingToWindow3);
export default __webpack_public_path__ + "static/media/new_ceiling_to_window_3.5e7200f121c5f6d9958c5e6a88d23a47.svg";
export { ForwardRef as ReactComponent };